import styled, { css } from 'styled-components';

import { CheckCircle } from '@mui/icons-material';
import { Link as MuiLink } from '@mui/material';

export const CheckIcon = styled(CheckCircle)`
  ${({ theme }) => css`
    fill: ${theme.palette.success.main};
  `}
`;

export const Link = styled(MuiLink)`
  ${({ theme }) => css`
    font-weight: ${theme.typography.fontWeightRegular};
  `}
`;
